var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ImportIntoUserGalleryDto } from '../../../../../shared/service-proxies/service-proxies';
import { ConfigureComponentBase } from '../../../../../shared/configure-component-base';
import * as _ from 'lodash';
import { finalize } from 'rxjs/operators';
import { GraphStateType } from '../../../gallery/graph-state';
import { GraphicsType } from '../../../shared/helpers/graphics-type-help';
import { GraphImportControlSettingComponent } from '../control/graph-import-control-setting.component';
import { CreateOrEditGraphComponent } from './create-or-edit-graph.component';
import { GallerySettingModalComponent } from './gallery-setting-modal.component';
import { AppConsts } from '../../../../../shared/AppConsts';
var GraphSettingComponent = /** @class */ (function (_super) {
    __extends(GraphSettingComponent, _super);
    function GraphSettingComponent(injector, abpSessionService, graphService, galleryService, modalService) {
        var _this = _super.call(this, injector) || this;
        _this.abpSessionService = abpSessionService;
        _this.graphService = graphService;
        _this.galleryService = galleryService;
        _this.modalService = modalService;
        _this.graphList = [];
        _this.currentGraphStates = [];
        _this.useGraph = false;
        _this.useGraphChange = new EventEmitter();
        _this.showModal = new EventEmitter();
        _this.hiddenUseGraph = false;
        _this.onShownCallback = function () { return _this.loadGalleryConfig(); };
        return _this;
    }
    GraphSettingComponent_1 = GraphSettingComponent;
    Object.defineProperty(GraphSettingComponent.prototype, "currentGraphState", {
        get: function () {
            return this._currentGraphState;
        },
        set: function (state) {
            if (state === this._currentGraphState) {
                return;
            }
            this._currentGraphState = state;
            if (state != null) {
                this.currentCustomStyle = this.graphService.getCustomStyle(this.graphSetting, state.index);
            }
            else {
                this.currentCustomStyle = null;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GraphSettingComponent.prototype, "fill", {
        get: function () {
            return this.currentCustomStyle ? this.currentCustomStyle.fill : undefined;
        },
        set: function (value) {
            if (!this.currentCustomStyle) {
                return;
            }
            if (value === this.currentCustomStyle.fill) {
                return;
            }
            if (value) {
                this.changeFillColor(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GraphSettingComponent.prototype, "stroke", {
        get: function () {
            return this.currentCustomStyle ? this.currentCustomStyle.stroke : undefined;
        },
        set: function (value) {
            if (!this.currentCustomStyle) {
                return;
            }
            if (value === this.currentCustomStyle.stroke) {
                return;
            }
            if (value) {
                this.changeStrokeColor(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    GraphSettingComponent.getGraphStateUrl = function (graphId, stateIndex, style) {
        var result = AppConsts.remoteServiceBaseUrl + "/Gallary/GetConfigureGraphState?graphId=" + graphId + "&stateIndex=" + stateIndex;
        if (style != null) {
            result += "&fill=" + encodeURIComponent(style.fill) + "&stroke=" + encodeURIComponent(style.stroke);
        }
        result += "&v=" + Math.floor(Date.now() / 1000);
        return result;
    };
    GraphSettingComponent.prototype.ngOnInit = function () {
        abp.event.on(this.graphSettingEventName, this.onShownCallback);
        if (this.loadOnInit) {
            this.loadGalleryConfig();
        }
    };
    GraphSettingComponent.prototype.ngOnDestroy = function () {
        abp.event.off(this.graphSettingEventName, this.onShownCallback);
    };
    GraphSettingComponent.prototype.loadGalleryConfig = function (graphName) {
        var _this = this;
        // TODO add loading.
        this.galleryService.getGraphs(this.configureId).subscribe(function (r) {
            _this.graphList = r.items;
            var loadByGraphName = graphName && graphName.length > 0;
            var graph;
            if (loadByGraphName) {
                graph = _.find(_this.graphList, function (g) { return g.name === graphName; });
            }
            else {
                graph = _.find(_this.graphList, function (g) { return g.id === _this.graphSetting.id; });
            }
            _this.selectGraph(graph);
        });
    };
    GraphSettingComponent.prototype.selectGraph = function (graph) {
        var _this = this;
        if (this.selectedGraph === graph) {
            return;
        }
        if (graph == null) {
            this.graphSetting.id = -1;
            this.graphSetting.styles = [];
            this.selectedGraph = null;
            this.currentGraphStates = null;
            this.currentGraphState = null;
            return;
        }
        if (this.graphSetting.id !== graph.id) {
            _.remove(this.graphSetting.styles);
        }
        this.selectedGraph = graph;
        this.graphSetting.id = graph.id;
        // TODO add loading.
        this.galleryService.getGraphStates(this.configureId, graph.id).subscribe(function (r) {
            _this.currentGraphStates = _.map(r.items, function (state) {
                var result = {
                    index: state.index,
                    name: _this.lc('State') + state.index,
                    graphState: state
                };
                if (state.type === GraphStateType.Svg) {
                    var style = _this.graphService.getCustomStyle(_this.graphSetting, state.index);
                    result.url = GraphSettingComponent_1.getGraphStateUrl(graph.id, state.index, style);
                }
                else {
                    result.url = AppConsts.remoteServiceBaseUrl + state.url;
                }
                return result;
            });
            if (_this.currentGraphStates.length > 0) {
                _this.currentGraphState = _this.currentGraphStates[0];
            }
        });
    };
    GraphSettingComponent.prototype.changeUseGraph = function (useGraph) {
        if (this.useGraph === useGraph) {
            return;
        }
        this.useGraph = useGraph;
        if (useGraph === true) {
            // TODO 从元件的默认图库图形里读取。
            var defaultGraph = void 0;
            if (this.graphList.length > 0) {
                defaultGraph = this.graphList[0];
            }
            this.selectGraph(defaultGraph);
        }
        else {
            this.selectGraph(null);
        }
        this.useGraphChange.emit(this.useGraph);
    };
    GraphSettingComponent.prototype.changeUseCustomStyle = function (useCustomStyle) {
        var _this = this;
        if (useCustomStyle) {
            var customStyle = { version: 1, stateIndex: this.currentGraphState.index };
            if (this._currentGraphState.graphState.canChangeFill) {
                customStyle.fill = 'rgb(0,0,0)';
            }
            if (this._currentGraphState.graphState.canChangeBorder) {
                customStyle.stroke = 'rgb(0,0,0)';
            }
            if (!this.graphSetting.styles) {
                this.graphSetting.styles = [];
            }
            this.graphSetting.styles.push(customStyle);
            this.currentCustomStyle = customStyle;
        }
        else {
            _.remove(this.graphSetting.styles, function (style) { return style.stateIndex === _this.currentGraphState.index; });
            this.currentCustomStyle = null;
        }
        this.refreshCustomCurrentStateUrl();
    };
    GraphSettingComponent.prototype.createOrEditGraph = function (id) {
        var _this = this;
        var input = { id: id, isImportGraph: false, graphicsType: GraphicsType.current };
        var modalRef = this.modalService.show(CreateOrEditGraphComponent, { initialState: { parameter: input, configureId: this.configureId }, backdrop: 'static' });
        var onClosedSub = modalRef.content.onClosed.subscribe(function (result) {
            if (result) {
                _this.loadGalleryConfig(result.graphName);
            }
            onClosedSub.unsubscribe();
        });
    };
    GraphSettingComponent.prototype.importGraph = function () {
        var _this = this;
        var modalRef = this.modalService.show(GallerySettingModalComponent, { initialState: { configureId: this.configureId }, backdrop: 'static', class: 'gallerySettingModal' });
        var onClosedSub = modalRef.content.onClosed.subscribe(function (result) {
            if (result) {
                _this.loadGalleryConfig(result.importedGraphName);
            }
            onClosedSub.unsubscribe();
        });
    };
    GraphSettingComponent.prototype.onAddToUserGallery = function () {
        var _this = this;
        var input = new ImportIntoUserGalleryDto();
        input.configureId = this.configureId;
        input.userId = this.abpSessionService.userId;
        input.configureGraphId = this.selectedGraph.id;
        input.graphName = this.selectedGraph.name;
        abp.ui.setBusy();
        this.galleryService.importConfigureGraphIntoUserGallery(input)
            .pipe(finalize(function () { return abp.ui.clearBusy(); }))
            .subscribe(function (r) {
            if (r === 0) {
                _this.notify.info(_this.lc('ImportSuccessfully'));
            }
            else {
                var value = {
                    graphId: _this.selectedGraph.id,
                    graphicsType: GraphicsType.current,
                    id: r,
                    list: _this.currentGraphStates,
                    name: _this.selectedGraph.name,
                    userId: input.userId
                };
                var modalRef = _this.modalService.show(GraphImportControlSettingComponent, {
                    initialState: { graphState: value, configureId: _this.configureId },
                    backdrop: 'static', class: 'graphImportControlSettingModal'
                });
                var onClosedSub_1 = modalRef.content.onClosed.subscribe(function (result) {
                    if (result) {
                    }
                    onClosedSub_1.unsubscribe();
                });
            }
        });
    };
    GraphSettingComponent.prototype.changeStrokeColor = function (color) {
        this.currentCustomStyle.stroke = color;
        this.refreshCustomCurrentStateUrl();
    };
    GraphSettingComponent.prototype.changeFillColor = function (color) {
        this.currentCustomStyle.fill = color;
        this.refreshCustomCurrentStateUrl();
    };
    GraphSettingComponent.prototype.refreshCustomCurrentStateUrl = function () {
        this._currentGraphState.url = GraphSettingComponent_1.getGraphStateUrl(this.selectedGraph.id, this._currentGraphState.index, this.currentCustomStyle);
    };
    GraphSettingComponent.prototype.setStrokeColor = function (color) {
        this.stroke = color;
    };
    GraphSettingComponent.prototype.setFillColor = function (color) {
        this.fill = color;
    };
    var GraphSettingComponent_1;
    __decorate([
        Input()
    ], GraphSettingComponent.prototype, "configureId", void 0);
    __decorate([
        Input()
    ], GraphSettingComponent.prototype, "useGraph", void 0);
    __decorate([
        Output()
    ], GraphSettingComponent.prototype, "useGraphChange", void 0);
    __decorate([
        Output()
    ], GraphSettingComponent.prototype, "showModal", void 0);
    __decorate([
        Input()
    ], GraphSettingComponent.prototype, "graphSetting", void 0);
    __decorate([
        Input()
    ], GraphSettingComponent.prototype, "loadOnInit", void 0);
    __decorate([
        Input()
    ], GraphSettingComponent.prototype, "hiddenUseGraph", void 0);
    GraphSettingComponent = GraphSettingComponent_1 = __decorate([
        Component({
            selector: 'graph-setting',
            styles: ["﻿.designer-graph-setting{ .graphSettingBox { height: 250px; background: #f2f3f8; overflow-x: auto; display: inline-block; .font12Size { font-size: 12px; } } .graphSvg, .graphPng { padding: 5px; border: 1px solid transparent; } .graphSvg.selectedGallery, .graphPng.selectedGallery { border-color: #2d89ef; } .stateBox { display: inline-block; width: 168px; width: 168px; margin-left: 3px; position: absolute; .graphSettingBox{ width: 100%; } } .graphBox { display: inline-block; width: 390px; .graphSettingBox{ width: 100%; } } .colorPick { width: 50px; } .span-inline-block { display: inline-block; width: 100%; } .backgroundBorder { background: #f2f3f8; padding:15px 10px; } .graphBtns{ margin-top: 5px; button{ height: 26px; line-height: 22px; margin-right:10px;  } } .editedState{ label.control-label{ display: block; width: 85px; height: 24px; line-height: 24px; margin-bottom: 0!important; } input.stroke{ width: 50px; } } .form-group{ margin-bottom: 15px; } .colorPicker{ width: 80px; height: 24px; border: 0; float: left; } .color-picker-content{ overflow: hidden; } .marginTop-10{ margin-top: 10px; } }"],
            template: "<div class='designer-graph-setting'> <div *ngIf=\"!hiddenUseGraph\" class=\"fe-form-title\"> <label for=\"useGraph\"> <input type=\"checkBox\" id=\"useGraph\" #changeUseGraphCheckBox [checked]=\"useGraph\" (change)=\"changeUseGraph(changeUseGraphCheckBox.checked)\"/>  <span>{{lc('UseGallery')}}</span> </label>         </div> <div class=\"form-group border-group\" *ngIf=\"useGraph\"> <div> <div class=\"graphBox\"> <div class=\"graphSettingBox\"> <graph-list [graphList]=\"graphList\" (graphSelected)=\"selectGraph($event)\" [selectedGraphId]=\"selectedGraph?.id\"></graph-list> </div> <div class=\"graphBtns\"> <button type=\"button\" class=\"fe-btn-small fe-btn-operate\" (click)=\"importGraph()\">{{lc(\"Import\")}}</button> <button type=\"button\" class=\"fe-btn-small fe-btn-operate\" (click)=\"createOrEditGraph()\">{{lc('CreateGraph')}}</button> <button type=\"button\" *ngIf=\"selectedGraph\" class=\"fe-btn-small fe-btn-operate\" (click)=\"onAddToUserGallery()\">{{lc(\"AddUserGallery\")}}</button> </div> </div> <div class=\"stateBox\"> <div class=\"graphSettingBox \"> <graph-states [states]=\"currentGraphStates\" [(selectedState)]=\"currentGraphState\"></graph-states> </div> <div class=\"graphBtns\"> <button type=\"button\" *ngIf=\"selectedGraph\" class=\"fe-btn-small fe-btn-operate\" (click)=\"createOrEditGraph(selectedGraph.id)\">{{lc('EditGraph')}}</button> </div> </div> </div> </div> <div class=\"padding-top-10\" *ngIf=\"useGraph&&currentGraphState&&(currentGraphState.graphState.canChangeFill || currentGraphState.graphState.canChangeBorder)\"> <div class=\"fe-form-title\"> <label for=\"useCustom\"> <input type=\"checkBox\" id=\"useCustom\" #currentCustomStyleCheckBox [checked]=\"currentCustomStyle\" (change)=\"changeUseCustomStyle(currentCustomStyleCheckBox.checked)\"/> <span>{{lc('ChangeStateStyle')}}</span> </label> </div> <div class=\"form-group backgroundBorder editedState\" *ngIf=\"currentCustomStyle\"> <div class=\"color-picker-content\"> <div *ngIf=\"currentGraphState&&currentGraphState.graphState.canChangeFill\" class=\"clearfix\"> <div style=\"float:left;\"> <label class=\"control-label\">{{lc('FillColor')}}</label> </div> <div class=\"colorPicker\"> <color-picker [color]=\"fill\" (sentColor)=\"setFillColor($event)\"></color-picker> </div> </div> <div *ngIf=\"currentGraphState&&currentGraphState.graphState.canChangeBorder\" class=\"marginTop-10 clearfix\"> <div style=\"float:left;\"> <label class=\"control-label\">{{lc('StrokeColor')}}</label> </div> <div class=\"colorPicker\"> <color-picker [color]=\"stroke\" (sentColor)=\"setStrokeColor($event)\"></color-picker> </div> </div> </div> </div> </div> </div> "
        })
    ], GraphSettingComponent);
    return GraphSettingComponent;
}(ConfigureComponentBase));
export { GraphSettingComponent };
